<template>
    <div>
        <rkm-row>
            <rkm-col cols="4">
                <rkm-form-select
                    label="Conclusão"
                    :options="form.conclusao"
                    v-model="model.conclusao"
                    value-field="id"
                    text-field="descricao"
                    :validations="validations.conclusao"
                    show-default-option
                    :disabled="model.exportacao"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row v-if="[1, 2, 3].includes(model.conclusao)">
            <rkm-col>
                <rkm-form-radio-group
                    v-model="model.justificativa"
                    :validations="validations.justificativa"
                    name="Justificativa"
                >
                    <rkm-form-radio
                        v-for="justificativa in form.elegivel"
                        :key="justificativa.id"
                        :value="justificativa.id"
                        :disabled="model.exportacao"
                    >
                        {{ justificativa.descricao }}
                    </rkm-form-radio>
                </rkm-form-radio-group>
            </rkm-col>
        </rkm-row>

        <rkm-row v-if="model.conclusao == 4">
            <rkm-col>
                <rkm-form-checkbox-group
                    v-model="model.justificativa"
                    :validations="validations.justificativa"
                    name="Justificativa"
                >
                    <rkm-form-checkbox
                        v-for="justificativa in form.inelegivel"
                        :key="justificativa.id"
                        :value="justificativa.id"
                        class="w-50 m-0"
                        :disabled="model.exportacao"
                    >
                        {{ justificativa.descricao }}
                    </rkm-form-checkbox>
                </rkm-form-checkbox-group>
            </rkm-col>
        </rkm-row>
    </div>
</template>

<script>
import conclusao from '@/enums/atencao-basica/avaliacao/conclusao'

export default {
    data: () => ({
        enums: {
            conclusao
        }
    }),
    computed: {
        validations() {
            return {
                conclusao: {
                    required: true
                },
                justificativa: {
                    required: true
                }
            }
        }
    },
    props: {
        model: { type: Object, required: false, },
        form: { type: Object, required: false, },
    },
    watch: {
        'model.conclusao': function() {
            if(this.model.conclusao == this.enums.conclusao.INELEGIVEL) {
                this.model.justificativa = []
            }
        }
    }
}
</script>